import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
/**
 * @hidden
 */
export var contentDisplayName = 'ActionSheetContent';
/**
 * The KendoReact ActionSheetContent component.
 */
export var ActionSheetContent = function (props) {
    return (React.createElement("div", { className: classNames('k-actionsheet-content', props.className) }, props.children));
};
ActionSheetContent.propTypes = {
    className: PropTypes.string
};
/**
 * @hidden
 */
ActionSheetContent.displayName = contentDisplayName;
/**
 * @hidden
 */
ActionSheetContent.propTypes = {
    children: PropTypes.any
};
